import apiConfig from "../../apiConfig";

export const getDonationSideDetails = async (at, donationSideId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Sides/Get_Donation_Side_Details",
		{ Donation_Side_Id: donationSideId },
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
